<template>
	<div content>
		<p>
			<strong>一、为什么上市前要进行细分市场调研?</strong>
		</p>
		<p>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“上市”是一种面向社会大众投资者和各种专业投资机构的融资行为，其审批流程十分严格。准上市企业所从事业务的成长性、创
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;新性以及市场竞争力是对上市资格进行核准或审批的主管机构所关注的重点。要想顺利通过预审并在上市核准会议上获得多数票，
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;就必须对企业所处的细分市场进行深入调研和分析，以确保上市申请报告及招股说明书中的描述准确、客观、具有说服力。
		</p>
		<p>
			<strong>二、美信咨询上市前细分市场调研服务内容</strong>
		</p>
		<p>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、客观描述准上市企业的业务发展潜力和市场竞争力，突出准上市企业的竞争优势及未来成长性；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、为准上市企业进行主营业务描述，制定中长期发展规划；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、对公司所处细分市场的创新性和成长性进行阐述和论证；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、为IPO招股说明书的撰写提供基础资料；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、提供符合招股说明书要求的行业研究文案；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6、缩短券商对准上市企业的尽职调查时间；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7、为券商招股书引用行业观点和数据提供客观支持；&nbsp;
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8、从行业研究角度协助券商把握准上市企业业务发展亮点及风险因素；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9、提升准上市企业知名度和IPO后投资价值；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10、为准上市企业上会审查提供第三方数据支持；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;11、为投资者和证监会展示准上市企业所处细分市场发展状况。
		</p>
		<p>
			<strong>三、美信咨询行业细分市场研究的优势</strong>
		</p>
		<p>
			<b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、强大的行业研究能力</b>
		</p>
		<p>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）美信咨询具有强大的行业研究能力。作为大中华地区领先的市场研究和投融资咨询公司，美信咨询每年可独立发布200余份
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;深度市场/行业研究报告，每份报告均提供中英文两个版本。我们的研究范围涵盖500多个热点行业。
		</p>
		<p>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）自成立以来，美信咨询已为包括西门子、三星、诺基亚、百超、IBM、索尼、ABB、MOTOROLA、东芝、普华永道、里昂
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;证券、&nbsp;世界银行、联合国工业发展组织等国际知名厂商和机构在内的700多家客户提供了市场调查和投融资服务。我们的
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;客户遍&nbsp;&nbsp;及全球130多个国家和地区。
		</p>
		<p>
			<b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、专业的研究团队</b>
		</p>
		<p>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）美信咨询是大中华地区较早开展IPO咨询服务的企业之一，在长期开展IPO咨询的过程中，我们的项目团队积累了丰富的
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;IPO咨询从业经验。&nbsp;
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）美信咨询的IPO项目团队成员90%以上拥有投资机构、会计师所、律师事务所、券商投资银行部、国际知名咨询公司工作背
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;景，他们主要来自摩根大通、麦肯锡、瑞银、IDC、IN-STAT、安永华明、君合律师事务所、中准会计师事务所、AC尼尔
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;森、邓&nbsp;白氏&nbsp;等。
		</p>
		<p>
			<b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、科学严谨的研究方法</b>&nbsp;
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）严格的项目质量控制流程；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）提供原始文件和详实的工作底稿；&nbsp;
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）应用先进的统计学方法和统计分析工具通过严谨的数据推导过程对原始数据进行综合分析和交叉验证；&nbsp;
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（4）通过询证的方式取得相关行业协会或主管部门的认可。
		</p>
		<p>
			<b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、强大的行业研究数据库</b>&nbsp;
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;基于与国家发改委、国家统计局、中国海关总署、各行业主管部门，以及各主要行业协会的良好关系，美信咨询拥有畅通的数据
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;采集渠道，可以获取1,200多个行业从2001年至今完整的统计数据和市场调查数据，其内容包括行业经济指标、进出口数据、价
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格数据、主要企业经营指标等。
		</p>
		<p>
			<b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、领先的行业资源</b>
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）&nbsp;在多年的行业研究和市场调研过程中，美信咨询的行业研究团队与多个行业的众多人士建立了良好的互动，包括上下游企
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业高&nbsp;管、大学教授、科研院所专家、行业协会和行业主管部门负责人等；&nbsp;
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）美信咨询已与万得、华通人、中国经济数据中心等十多个领先的数据提供商建立了行业研究数据交换机制，拥有强大的外
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;部数据库支持。
		</p>
		<p>
			<strong>四、美信咨询行业细分市场研究报告框架</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
		</p>
		<p>
			&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;第一章 研究概述
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第二章 全球及我国XXX行业政策与发展特征分析
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第三章 产业链上下游分析及关键成功要素（KSF）分析
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第四章 XXX行业技术发展现状及趋势分析
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第五章 XXX行业进入障碍分析
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第六章 全球XXX市场行业现状、市场容量推测及发展趋势
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第七章 全球XXX市场供需分析
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第八章 中国XXX市场行业现状、市场容量推测及发展趋势
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第九章 中国XXX市场供需分析
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第十章 2007~2010年中国XXX市场重点企业竞争力分析
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第十一章 上游行业经营特征、议价能力分析
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第十二章 下游行业需求分析
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第十三章 定量风险因素分析
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第十四章 细分市场与技术研究结论
		</p>
		<p>
			<strong>五、美信咨询IPO上市前细分市场研究流程</strong>
		</p>
		<p>
			<img :src="image" width="548" height="450" align="middle" />
		</p>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				image: require('@/assets/ipo.jpg')
			};
		}
	}
</script>
